import getFetchWrapper from 'syf-api/api/getFetchWrapper';
import ENDPOINTS from '../../../const/endpoints';
const queryFnFactory = (config, keyProps, headers = {}) => {
    const fetchWrapper = getFetchWrapper(config);
    return () => {
        const params = new URLSearchParams({
            'cipher.accountId': keyProps.accountId
        });
        if (keyProps.accountIdType) {
            params.set('accountIdType', keyProps.accountIdType);
        }
        return fetchWrapper(`${ENDPOINTS.authorizedUsers}?${params}`, {
            method: 'GET',
            headers: {
                ...headers
            }
        });
    };
};
export default queryFnFactory;
